import { ExpenseClaimState } from './../../../../core/models/expense.model';
import { Component, Input, OnInit } from '@angular/core';
import { DateHelper } from 'app/core/helpers/date-helper';
import { ExpenseClaimPaidBy, ExpenseClaimViewModel } from 'app/core/models/expense.model';
import { OverBudgetRequestDetailsStatus } from 'app/core/models/project-management.model';

@Component({
  selector: 'app-expense-state-badge',
  templateUrl: './expense-state-badge.component.html',
  styleUrls: ['./expense-state-badge.component.scss']
})
export class ExpenseStateBadgeComponent implements OnInit {
  @Input() expense: ExpenseClaimViewModel;
  @Input() selectedTab: ExpenseClaimState;
  @Input() dataLoaded: boolean;

  ExpenseClaimState = ExpenseClaimState;
  OverBudgetRequestDetailsStatus = OverBudgetRequestDetailsStatus;

  constructor() { }

  ngOnInit(): void {
  }

  getPaidByText(paidBy: ExpenseClaimPaidBy) {
    switch (paidBy) {
      case ExpenseClaimPaidBy.Finance:
        return 'Paid via Finance';
      case ExpenseClaimPaidBy.Caxton:
        return 'Paid via Caxton Bank';
      case ExpenseClaimPaidBy.CaxtonCard:
        return 'Paid via Caxton Card';
      case ExpenseClaimPaidBy.NmibleCard:
        return 'Paid via Nmible Card';
      case ExpenseClaimPaidBy.NmibleBank:
        return 'Paid via Nmible Bank';
    }
  }

  getBadgeClass() {
    switch (this.expense.state) {
      case ExpenseClaimState.Pending:
      case ExpenseClaimState.AutomatedPaymentFailed:
        return 'badge-warning';
      case ExpenseClaimState.Approved:
      case ExpenseClaimState.AutomatedPaymentApproved:
      case ExpenseClaimState.Processing:
        return 'badge-success';
      case ExpenseClaimState.Rejected:
        return 'badge-danger';
      default:
        return 'badge-grey';
    }
  }

  getBadgeText() {
    switch (this.expense.state) {
      case ExpenseClaimState.AutomatedPaymentApproved:
        return 'Automated Payment Approved';
      case ExpenseClaimState.AutomatedPaymentFailed:
        return 'Automated Payment Failed';
      case ExpenseClaimState.Processing:
        return 'Payment Processing';
      default:
        return this.expense.state;
    }
  }

  isCaxtonTab() {
    return this.selectedTab === ExpenseClaimState.AutomatedPaymentApproved || this.selectedTab === ExpenseClaimState.Processing || this.selectedTab === ExpenseClaimState.AutomatedPaymentFailed;
  }

  getLocalDate(date: Date) {
    return this.isCaxtonTab() ? DateHelper.dateUTCToLocal(date) : date;
  }
}
